import React from 'react'


type AppProps = {
    formError: any;
    setFormError: (data: any) => void;
    setInputDetails: (data: any) => void;
    inputDetails:any;
}

const TaxDetails = ({
    formError,
    setFormError,
    setInputDetails,
    inputDetails
}: AppProps) => {
    
    const handleTaxDetailsChange = (e: any) => {
        let Name = e.target.name;
        let Value = e.target.value;
         if (Name === 'cess') {
            if(Value>=0){
                setInputDetails((prev: any) => ({
                    ...prev,
                    cess: Value
                }))
            }
        }
        else if (Name === 'gst') {
            
            if(Value>=0){
                setFormError((prev: any) => ({
                    ...prev,
                    gstError: '',
                }))
                setInputDetails((prev: any) => ({
                    ...prev,
                    gst: Value
                }))
            }
        }
    }

    return (
        <>
            <div className="col-md-12">
                <h4>Tax Type :</h4>
                <div className='row'>
                    <div className="col-md-4">
                        <form>
                            <div className="form-group mt-3">
                                <div>
                                    <label htmlFor="CESS"
                                    className={inputDetails?.cess? "active" : ""}
                                    >CESS%</label>
                                    <input
                                        type="number"
                                        className={`form-control ${!!formError.cessError ? "error-border" : null}`}
                                        name="cess"
                                        value={inputDetails?.cess}
                                        onChange={(e) => handleTaxDetailsChange(e)}
                                        onWheel={event => event.currentTarget.blur()}
                                    />
                                    {!!formError.cessError && (
                                        <small className="text-danger">{formError.cessError}</small>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-4">
                        <form>
                            <div className="form-group mt-3">
                                <div>
                                    <label htmlFor="GST"
                                    >GST%*</label>
                                    <input
                                        type="text"
                                        className={`form-control ${!!formError.gstError ? "error-border" : null}`}
                                        name="gst"
                                        value={inputDetails?.gst}
                                        onChange={(e) => handleTaxDetailsChange(e)}
                                        maxLength={15}
                                    />
                                    {!!formError.gstError && (
                                        <small className="text-danger">{formError.gstError}</small>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TaxDetails;